import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { ProductForm } from "@/features/products";
import { apiClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const EditProduct = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchOutlet = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              skuPrefix,
              status,
              availableToAllOutlets,
              productCategoryId,
              productCategory,
              unitOfMeasurementId,
              unitOfMeasurement,
              productVariants,
              productAddOns,
              outlets,
              productVariantAttributeValue,
            },
          },
        } = await apiClient.get(`products/${productId}`, {
          params: {
            withVariants: true,
            withOutlets: true,
            withProductCategory: true,
            withUom: true,
            withProductVariantAttributeValue: true,
            withProductAddOns: true,
          },
        });

        // Construct variant attributes
        const variantAttributes = [];

        if (productVariantAttributeValue.variantAttribute1) {
          variantAttributes.push({
            attribute: {
              id: productVariantAttributeValue.variantAttribute1Id,
              name: productVariantAttributeValue.variantAttribute1.name,
            },
            values: productVariantAttributeValue.variantAttribute1Values,
          });
        }

        if (productVariantAttributeValue.variantAttribute2) {
          variantAttributes.push({
            attribute: {
              id: productVariantAttributeValue.variantAttribute2Id,
              name: productVariantAttributeValue.variantAttribute2.name,
            },
            values: productVariantAttributeValue.variantAttribute2Values,
          });
        }

        if (productVariantAttributeValue.variantAttribute3) {
          variantAttributes.push({
            attribute: {
              id: productVariantAttributeValue.variantAttribute3Id,
              name: productVariantAttributeValue.variantAttribute3.name,
            },
            values: productVariantAttributeValue.variantAttribute3Values,
          });
        }

        if (productVariantAttributeValue.variantAttribute4) {
          variantAttributes.push({
            attribute: {
              id: productVariantAttributeValue.variantAttribute4Id,
              name: productVariantAttributeValue.variantAttribute4.name,
            },
            values: productVariantAttributeValue.variantAttribute4Values,
          });
        }

        let retailPrice = 0;
        let distributorPrice = 0;
        if (variantAttributes.length === 0 && productVariants.length > 0) {
          // Assuming the price is in the first variant
          retailPrice = productVariants[0].retailPrice;
          distributorPrice = productVariants[0].distributorPrice;
        }

        // Map the outlets
        const outletMap = outlets.reduce((acc, outlet) => {
          acc[outlet.id] = true;
          return acc;
        }, {});

        setDefaultValues({
          name,
          stockKeepingUnitPrefix: skuPrefix,
          status,
          availableToAllOutlets,
          productCategory: {
            id: productCategoryId,
            name: productCategory.name,
          },
          unitOfMeasurement: {
            id: unitOfMeasurementId,
            name: unitOfMeasurement.name,
          },
          retailPrice,
          distributorPrice,
          variantAttributes,
          productVariants,
          productAddOns,
          outlets: outletMap,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchOutlet();
  }, [productId]);

  const handleSubmit = async (payload) => {
    try {
      await apiClient.put(`products/${productId}/bulk`, payload);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui produk")
      );
    }
  };

  return isLoading ? (
    <CenteredLoading />
  ) : (
    <PageContainer
      maxWidth="xl"
      title="Edit Produk"
      breadcrumbs={[
        { title: "Produk Umum", path: "/inventory/products" },
        { title: "Ubah" },
      ]}
    >
      <ProductForm
        disableStockKeepingUnitPrefix={true}
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
